import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { Subscription } from 'rxjs';
import { CommonValues } from 'src/app/services/commonValues';
import { AppSettings } from './../../services/AppSettings';
import { ApiService } from './../../services/api.service';
import { UtilService } from './../../services/util.service';
import { UserService } from 'src/app/services/UserService';
import { JobService } from 'src/app/services/job.service';
import { CurrentOrganizationProviderService } from 'src/app/services/current-organization-provider.service';

@Component({
  selector: 'app-profile-completion',
  standalone: true,
  imports: [CommonModule, NgCircleProgressModule],
  templateUrl: './profile-completion.component.html',
  styleUrls: ['./profile-completion.component.scss']
})
export class ProfileCompletionComponent implements OnInit, OnDestroy {
  ProfileComplete: any = []
  eventEmitter: Subscription
  creationPage: boolean = false
  userType=localStorage.getItem('userType');
  @Input() suggestion: any;
  constructor(private util: UtilService,
    public currentOrgProvider : CurrentOrganizationProviderService,
    private userService: UserService,private JobServicecolor: JobService, private api: ApiService, private router: Router, private commonvalues: CommonValues, private activateroute: ActivatedRoute) {
    var a = this.router.url
    var b = a.slice(1, 11)
    if (b === 'userDetail') {
      this.creationPage = true
      if (this.ProfileComplete.photo == null || this.ProfileComplete.photo == undefined || this.ProfileComplete.photo == "") {
        this.ProfileComplete.photo = "assets/images/userAvatar.png"
      }
    } else {
      this.creationPage = false;
      if (this.ProfileComplete.photo == null || this.ProfileComplete.photo == undefined || this.ProfileComplete.photo == "") {
        this.ProfileComplete.photo = "assets/images/userAvatar.png"
      }
    }

    // this.eventEmitter = this.commonvalues.getRefresh().subscribe(res=>{
    //   this.ProfileComplete.completePercentage =
    // })
  }
  @Input() inputData: string;
  show = false;
  ngOnInit() {
    // this.profileStatus();
    if (this.creationPage === true) {
      this.commonvalues.getUserData().subscribe(re => {
        this.ProfileComplete = re
      })
    }

    this.profielCompletionDetails();

  }

    // if image is not there i will generate the name first letter and last letter
    generateInitialsImageSrc(firstName: string, lastName: string): string {
      const initials = this.getInitials(firstName, lastName);
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      // Set canvas size
      canvas.width = 100;
      canvas.height = 100;

      // Draw background
      context.fillStyle = this.getColor(firstName, lastName);
      context.fillRect(0, 0, 100, 100);

      // Draw text (initials)
      context.fillStyle = '#ffffff';
      context.font = '40px Arial';
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.fillText(initials, 50, 50);

      // Convert canvas to data URL
      const dataUrl = canvas.toDataURL('image/png');

      return dataUrl;
    }
    generateProgressPath(percentage: number): string {
      const radius = 50;
      const centerX = 50;
      const centerY = 50;
      const startAngle = -90; // Start at the top
      const endAngle = startAngle + (percentage / 100) * 360;

      const startRadians = (startAngle * Math.PI) / 180;
      const endRadians = (endAngle * Math.PI) / 180;

      const startX = centerX + radius * Math.cos(startRadians);
      const startY = centerY + radius * Math.sin(startRadians);

      const endX = centerX + radius * Math.cos(endRadians);
      const endY = centerY + radius * Math.sin(endRadians);

      const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';

      return `M ${startX} ${startY} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${endX} ${endY}`;
    }

  ngOnDestroy(): void {
    if (this.eventEmitter) {
      this.eventEmitter.unsubscribe();
    }
  }

  organizationname: any;
  loadAPIcall = false;
  title: any;

  profielCompletionDetails() {
    this.loadAPIcall = true;
    this.userService.userProfileComplete(localStorage.getItem('userId')).subscribe(res => {
      this.loadAPIcall = false;
      this.ProfileComplete = res;
      const workExperience = this.ProfileComplete.workExperience;
      if (workExperience.length > 0) {
        const currentExperience = workExperience.find(ele => ele.currentOrganization);

        if (currentExperience) {
          this.organizationname = currentExperience.organisationName;
          this.title = currentExperience.title;
        }

      }

    });
  }
  getInitials(firstname: string, lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname, lastname);
  }

  getColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname, lastname);
  }

  getTextColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getTextColor(firstname, lastname);
  }

  route(userid) {
    userid = localStorage.getItem('userId')
    if (userid != undefined && userid != null && userid != "") {
      let datas: any = {};
      datas.userId = userid
      this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
        this.router.navigate(["personalProfile"], { queryParams: datas });
      });
    }
  }

  ngAfterViewInit(): void {
    setInterval(() => {
      if (localStorage.getItem('profileImage') != undefined) {
        this.ProfileComplete.photo = localStorage.getItem('profileImage');
      }
    }, 2000);
  }


  profileStatus() {
    if (this.inputData && this.inputData != "") {
      let datas: any = {};
      datas.userId = localStorage.getItem('userId')
      if (this.creationPage === false) {
        this.util.startLoader()
        this.api.query("user/profile/complete/" + localStorage.getItem('userId')).subscribe(res => {
          if (res != undefined && res) {
            this.util.stopLoader()
            if (res.photo == undefined || res.photo == null || res.photo == "") {
              res.photo = 'assets/images/userAvatar.png';
            } else {
              res.photo = AppSettings.photoUrl + res.photo;
            }

            this.ProfileComplete = res;

            if (this.inputData == "PROFILE_CREATE_PAGE" || res.completePercentage == 100) {
              this.show = false;
            } else {
              this.show = true;
            }
          }
        }, err => {
          if (err.status == 500) {
            this.util.stopLoader()
          }
        });
      }
    }
  }
}
